import { formatCurrency, formatDate } from '@if/core/utils'
import DeleteIcon from '@mui/icons-material/Delete'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Badge, IconButton, Tooltip } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid'
import { EInteracWireStatus, ESystemMatchingResult, InteracWire } from '@src/types/interac'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface ActionsProps {
  onView: (item: InteracWire) => void
  onViewUnknown: (item: InteracWire) => void
  onDelete: (item: InteracWire) => void
}

const unknownDetailView = [ESystemMatchingResult.None, ESystemMatchingResult.Error];
export const useUnmatchedInteracWireColumns = ({
  onView,
  onViewUnknown,
  onDelete,
}: ActionsProps): GridColDef<InteracWire>[] => {
  const { t } = useTranslation();
  return useMemo<GridColDef<InteracWire>[]>(
    () => [
      {
        field: 'receivedOn',
        headerName: t('common.date'),
        sortable: false,
        minWidth: 130,
        disableColumnMenu: true,
        valueFormatter: (ReceivedOn: Date) => {
          if (ReceivedOn.toString() === '0001-01-01T00:00:00') return ''
          return formatDate(ReceivedOn)
        },
      },
      {
        field: 'amount',
        headerName: t('interacWire.amount'),
        sortable: false,
        align: 'right',
        disableColumnMenu: true,
        valueFormatter: formatCurrency,
      },
      {
        field: 'sentBy',
        headerName: t('interacWire.from'),
        flex: 1,
        sortable: false,
        disableColumnMenu: true,
        valueGetter: (_value, row) => {
          return `${row.sentBy} (${row.senderEmail})`
        },
      },
      {
        field: 'message',
        headerName: t('interacWire.message'),
        flex: 1,
        sortable: false,
        disableColumnMenu: true,
      },
      {
        field: 'actions',
        headerName: '',
        sortable: false,
        filterable: false,
        hideable: false,
        disableColumnMenu: true,
        resizable: false,
        align: 'right',
        renderCell: ({ row }) => {
          return (
            <>
              <Tooltip title={t('common.details')}>
                <IconButton
                  onClick={() =>
                    unknownDetailView.some(v => row.systemMatchingResult === v ) ? onViewUnknown(row) : onView(row)
                  }
                >
                  <Badge color="warning" badgeContent="!" invisible={row.status != EInteracWireStatus.InProcess}>
                    <OpenInNewIcon />
                  </Badge>
                </IconButton>
              </Tooltip>
              <Tooltip title={t('common.delete')}>
                <IconButton onClick={() => onDelete(row)} color="error">
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </>
          )
        },
      },
    ],
    [onDelete, onView, onViewUnknown, t],
  )
}
